import React, { useCallback } from 'react';
import { DropdownMenu, AccessibleDataTableColumn } from '@aidkitorg/component-library';
import { useLocalizedStrings } from '../../../../Localization';
import { downloadTableAsCSV, downloadTableAsXLSX } from '../../utils/tableExport';

type ChartDataExportDropdownProps = {
  data: Record<string, any>[];
  columns: AccessibleDataTableColumn[];
  title: string;
};

export const ChartDataExportDropdown: React.FC<ChartDataExportDropdownProps> = ({
  data,
  columns,
  title,
}) => {
  const L = useLocalizedStrings();

  const downloadAsCSV = useCallback(() => {
    downloadTableAsCSV(data, columns, title);
  }, [data, columns, title]);

  const downloadAsXLSX = useCallback(() => {
    downloadTableAsXLSX(data, columns, title, 'Chart Data');
  }, [data, columns, title]);

  if (data.length === 0) {
    return null;
  }

  return (
    <DropdownMenu
      label={L.admin_panel.dashboards.download}
      icon="ArrowDownTrayIcon"
      anchor="bottom"
      align="end"
      options={[
        {
          label: L.admin_panel.dashboards.download_as_csv,
          callback: downloadAsCSV,
        },
        {
          label: L.admin_panel.dashboards.download_as_xlsx,
          callback: downloadAsXLSX,
        },
      ]}
    />
  );
};
